import { css } from 'lit';

export const q1AlertBarStyles = css`

  :host {
    display: block;
    color: var(--q1-alert-text-color, white);

    /* light variant defaults */
    --q1-alert-bg: white;
    --q1-alert-text-color: var(--gray-7);
  }
  :host(:not([open])) {
    display: none;
  }

  alert-base {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem 0.5rem;

    background: var(--q1-alert-bg);
    color: var(--q1-alert-text-color);
    border-radius: 3px;
    padding: 0.5rem 1rem;
    box-shadow: var(--sl-shadow-medium); 
  }
  alert-base.disabled {
    opacity: 0.4;
  }

  /*=== CORE CONTENT ===*/
  
  #content {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  #message {
    font-weight: 500;
  }
  
  sl-icon#icon {
    color: var(--q1-alert-text-color);
    font-size: 1.4rem;
    opacity: 0.5;
  }
  
  /*=== BUTTONS ===*/

  #buttons {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  sl-dropdown#snooze-dropdown::part(trigger) {
    display: flex;
  }

  sl-icon-button#snooze-button {
    font-size: 1.4rem;
  }
  sl-icon-button#snooze-button::part(base) {
    padding: 0;
  }

`;
